import type { SnippetMap } from "./types";

export const secretSnippets: SnippetMap = {
  python: ({ token }) => `import oo

# Simple one-liner to fetch a secret
secret = oo.get_secret("${token}")
print(f"Secret: {secret}")`,

  javascript: ({ token, baseUrl }) => `// Fetch a secret using the Double-O API
const response = await fetch("${baseUrl}/api/secret", {
  headers: {
    Authorization: "Bearer ${token}",
  },
});
const data = await response.json();
console.log("Secret:", data.value);`,

  curl: ({ token, baseUrl }) =>
    `curl "${baseUrl}/api/secret" \\
  -H "Authorization: Bearer ${token}"`,

  r: ({ token, baseUrl }) => `library(httr2)

# Fetch a secret from Double-O
resp <- request("${baseUrl}/api/secret") |>
  req_headers(Authorization = paste("Bearer", "${token}")) |>
  req_perform()

secret <- resp_body_json(resp)$value
print(paste("Secret:", secret))`,
};
